import styled from "styled-components";

export const ProductsGridWrapper = styled.div`
  padding: 40px 0 20px;
  & h4 {
    font-family: "Poppins";
    font-style: normal;
    font-weight: 600;
    font-size: 36px;
    line-height: 126.2%;
    color: ${(props) => props.theme.textColor};
    text-align: center;
    @media (max-width: 768.98px) {
      font-size: 32px;
    }
  }
`;

export const ProductsGridMain = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: 40px;
`;

export const MarketplaceButton = styled.button`
  width: 100%;
  height: 70px;
  background: transparent;
  border: 2px solid ${(props) => props.theme.textColor};
  border-radius: 37px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 126.2%;
  color: ${(props) => props.theme.textColor};
  cursor: pointer;
  transition: 0.2s;
  &:hover {
    color: #0088cc;
    border: 2px solid #0088cc;
  }
`;
